
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { ElForm, ElFormItem, ElRow, ElCol } from 'element-plus';
import ElSelectExt from "@/components/ElSelectExt.vue";

const componentMap: any = {
  ElSelectExt
}

interface SearchColumn {
  columnName: string;
  columnComment: string;
  componentType: string;
  options?: Record<string, any>;
}

export default defineComponent({
  name: 'DynamicSearchForm',
  components: {
    ElForm,
    ElFormItem,
    ElRow,
    ElCol,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    searchColumns: {
      type: Array as PropType<SearchColumn[]>,
      required: true,
    },
    labelWidth: {
      type: String,
      default: '100px',
    },
    colLayout: {
      type: Object,
      default: () => ({ span: 4 }),
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const searchForm = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    })

    const getComponent = (item: any) => {
      const componentName = item.component
      const component = componentMap[componentName]
      if (!component) {
        if(componentName == 'el-switch') {
          return ElSelectExt
        }else {
          return componentName
        }
      }
      return component
    }

    const formatSearchOptions = (item: any) => {
      const result = JSON.parse(item.componentOptions)
      result.type = result.searchType
      return result
    }

    const formatLabel = (label: string) => {
      // 截取label，只取第一个（之前的字符
      if (label.indexOf('（') === -1) return label
      return label.substring(0, label.indexOf('（'))
    }

    // 监听整个 searchForm 的变化
    // watch(searchForm, (newVal) => {
    //   console.log('searchForm changed:', newVal);
    //   if (newVal.report_time === null) {
    //     // 如果 report_time 为 null，则将其设置为空数组
    //     newVal.report_time = [];
    //     // 通知父组件更新值
    //     emit('update:modelValue', newVal);
    //   }
    // }, { deep: true });

    return {
      searchForm,
      getComponent,
      formatSearchOptions,
      formatLabel,
    }
  }
})
